module.exports = __webpack_public_path__ + "static/em_capabilities_3_4-553d1229b03b2789bca3b9553ca6c826.png";